import { render, staticRenderFns } from "./OrganisationBankAccountSelect.vue?vue&type=template&id=0fd0c4da&"
import script from "./OrganisationBankAccountSelect.vue?vue&type=script&lang=js&"
export * from "./OrganisationBankAccountSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports